import axios from 'axios';

const shouldRetryRemoteRequest = (error) => {
  const status = error?.response?.status;
  if (!status) return true;
  return status >= 500;
};

const shouldFallbackToControllersRoute = (path, error) => {
  if (shouldRetryRemoteRequest(error)) {
    return true;
  }
  const status = error?.response?.status;
  if (status !== 404) {
    return false;
  }
  return path === 'state';
};

export const remotePost = async (path, payload, { allowAlternateRoute = true, timeout } = {}) => {
  try {
    return await axios.post(`/api/remote/${path}`, payload, ...(timeout ? [{ timeout }] : []));
  } catch (err) {
    if (!allowAlternateRoute || !shouldFallbackToControllersRoute(path, err)) {
      throw err;
    }
    return axios.post(`/controllers/api/remote/${path}`, payload);
  }
};

export const requestRemoteState = async ({ deviceId, includeScreenshot, allowAlternateRoute = true, timeout }) => {
  const res = await remotePost('state', { deviceId, includeScreenshot }, { allowAlternateRoute, timeout });
  return res.data?.state || null;
};
